import Dialog from "../../components/Dialog";
import IModalProps from "../../model/ModalProps";
import { IActivityManagementDetails } from "../../model/Calendar";
import ButtonStyles from "../../styles/components/ButtonStyles";
import {
    StyledCenterDiv,
    StyledP,
    StyledSpaceBetweenDiv,
    StyledTextP,
} from "../../styles/MainStyles";
import {
    StyledModalDiv,
    StyledModalTitle,
} from "../../styles/pages/Calendar/ModalInfoManagementStyles";

const { BtnPrimary } = ButtonStyles;

interface IModalInfoManagementActivity
    extends IActivityManagementDetails,
        IModalProps {}

const ModalInfoManagementActivity: React.FC<IModalInfoManagementActivity> = ({
    insertedPersonName,
    insertedPersonRegistration,
    referenceStartDate,
    referenceEndDate,
    justificationEndDate,
    approvalEndDate,
    open,
    onClose,
}) => {
    const formatDate = (date: Date) => {
        return new Intl.DateTimeFormat("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).format(date);
    };

    const showName = (name: string) => {
        const nameArr = name.split(" ");
        return `${nameArr[0]} ${nameArr[nameArr.length - 1]}`;
    };

    return (
        <Dialog openModal={open} onHide={onClose}>
            <StyledModalTitle>Informações</StyledModalTitle>
            <h5>Gestão de atividades</h5>
            <StyledModalDiv>
                <StyledSpaceBetweenDiv>
                    <StyledP>Incluído/Editado por:</StyledP>
                    {referenceStartDate && (
                        <StyledTextP>
                            {showName(insertedPersonName)}
                        </StyledTextP>
                    )}
                </StyledSpaceBetweenDiv>
                <StyledSpaceBetweenDiv>
                    <StyledP>Matrícula:</StyledP>
                    {referenceStartDate && (
                        <StyledTextP>{insertedPersonRegistration}</StyledTextP>
                    )}
                </StyledSpaceBetweenDiv>
                <StyledSpaceBetweenDiv>
                    <StyledP>Início Referência:</StyledP>
                    {referenceStartDate && (
                        <StyledTextP>
                            {formatDate(referenceStartDate)}
                        </StyledTextP>
                    )}
                </StyledSpaceBetweenDiv>
                <StyledSpaceBetweenDiv>
                    <StyledP>Fim Referência:</StyledP>
                    {referenceEndDate && (
                        <StyledTextP>
                            {formatDate(referenceEndDate)}
                        </StyledTextP>
                    )}
                </StyledSpaceBetweenDiv>
                <StyledSpaceBetweenDiv>
                    <StyledP>Data Limite para Justificar:</StyledP>
                    {justificationEndDate && (
                        <StyledTextP>
                            {formatDate(justificationEndDate)}
                        </StyledTextP>
                    )}
                </StyledSpaceBetweenDiv>
                <StyledSpaceBetweenDiv>
                    <StyledP>Data Limite para aprovação:</StyledP>
                    {approvalEndDate && (
                        <StyledTextP>{formatDate(approvalEndDate)}</StyledTextP>
                    )}
                </StyledSpaceBetweenDiv>
            </StyledModalDiv>
            <StyledCenterDiv>
                <BtnPrimary onClick={onClose}>Fechar</BtnPrimary>
            </StyledCenterDiv>
        </Dialog>
    );
};

export default ModalInfoManagementActivity;
